<template>
    <UserPageLayout>
        <div style="margin-bottom: 2rem">
            <h1 class="system-text-color system-text-shadow text-center text-3xl">{{ $t('report_title') }}</h1>

            <p class="system-text-color system-text-shadow text-xl text-center">
                {{ $t('report_sub_title', { reportCount: countReport, quizTitle: quiz.title || '' }) }}
            </p>
        </div>

        <div class="max-w-xl m-auto">
            <ReportThumbnail
                @count-report="getCountReport"
                @open-payment="setShowPaymentPopup"
                @receive-report-data="onReceiveReportData"
                :page="'report'"
                :show-upgrade-alert="true"
                ref="reportThumbnail"
            />
        </div>

        <div class="max-w-xl m-auto text-center py-4">
            <router-link class="system-text-color system-text-shadow font-size-16" :to="{ name: 'my-quiz' }">
                {{ $t('report_back_to_my_quiz') }}
            </router-link>
        </div>

        <ReportDetailModal
            v-if="showReportDetailModal"
            @close="showReportDetailModal = false"
            :report="currentReportDetail"
        />

        <PaymentPopup
            v-if="isShowPaymentPopup"
            @close="onClosePaymentPopup"
            @success="paymentSuccess"
            :payment-title="paymentModalTitle"
        />

        <MergeReportModal v-if="isShowMergeReportModal" @close="onCloseMergeReportModal" />
    </UserPageLayout>
</template>

<script>
import Request from '@/lib/request'
import UserService from '@/lib/user'
import UserPageLayout from '@/layouts/UserPage'
import appConfig from '@/app.config'
import ReportDetailModal from '@/components/ReportDetailModal'
import popup from '@/lib/popup.js'
import ReportThumbnail from '@/components/ReportThumbnail'
import MergeReportModal from '@/components/merge-report/MergeReportModal'
import IntroHint from '@/lib/intro.js'
import { mapGetters } from 'vuex'
import PaymentPopup from '@/components/PaymentPopup'

export default {
    components: {
        UserPageLayout,
        ReportDetailModal,
        ReportThumbnail,
        PaymentPopup,
        MergeReportModal
    },

    data() {
        return {
            quiz: {},
            showReportDetailModal: false,
            currentReportDetail: {
                players: []
            },
            countReport: 0,
            introHint: new IntroHint()
        }
    },

    mounted() {
        // We can remove thsi later, we have same function in "ReportThumbnail"
        // this.getReportByUser()

        this.introHint.removeHints()

        document.addEventListener('click', e => {
            if (e.target.classList.contains('link-upgrade')) {
                this.setShowPaymentPopup()
            }
        })
    },

    computed: {
        ...mapGetters({
            paymentModalTitle: 'paymentModalTitle',
            isShowPaymentPopup: 'isShowPaymentPopup',
            isShowMergeReportModal: 'isShowMergeReportModal'
        })
    },

    methods: {
        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        getReportByUser() {
            const request = this.createRequest()
            const quizId = this.$route.params.quizId
            const url = appConfig.api.getReportByUser.replace(/__id__/, quizId)

            request
                .get(url)
                .then(res => {
                    this.quiz = res.data.data.quiz
                })
                .catch(err => {
                    if (err.response.status === 403) {
                        return popup.alert('You dont have permission to access this quiz', () => {
                            window.location.href = '/'
                        })
                    }
                })
        },

        listPlayerInReport(report) {
            const reportId = report._id.$oid
            const request = this.createRequest()

            this.$store.commit('toggleMainLoader', true)

            request
                .get(appConfig.api.listPlayerInReport.replace(/__id__/, reportId))
                .then(res => {
                    this.showReportDetailModal = true
                    this.currentReportDetail = {
                        players: res.data.data
                    }
                    this.$store.commit('toggleMainLoader', false)
                })
                .catch(() => {
                    this.$store.commit('toggleMainLoader', false)
                })
        },

        getCountReport(count) {
            this.countReport = count
            this.isDataLoaded = false
        },

        setShowPaymentPopup() {
            this.$store.commit('setPaymentModalTitleDescription', {
                title: this.$t('my_quiz_payment_modal_create_more_quiz_title'),
                description: this.$t('my_quiz_payment_modal_create_more_quiz_description')
            })

            this.$store.commit('openPaymentPopup', true)
        },

        onClosePaymentPopup() {
            this.$store.commit('openPaymentPopup', false)
        },

        async paymentSuccess() {
            this.$store.dispatch('findOrderAbility')
            this.onClosePaymentPopup()
        },

        onReceiveReportData(reportData) {
            this.quiz = reportData.quiz
        },

        onCloseMergeReportModal() {
            this.$store.commit('setMergeReportModal', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.report-row {
    border-radius: 4px;
}

.report-download-box {
    position: relative;

    .report-dropdown-box {
        top: 50px;
        left: 0;
        position: absolute;
        min-width: 100px;
        height: auto;
        background-color: #fff;
        border: 1px solid #000;
        border-radius: 0.25rem;
        z-index: 2;

        .arrow-up {
            position: absolute;
            top: -8px;
            left: 22px;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid black;
        }

        .dropdown-option {
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 90%;
                height: 100%;
                border-bottom: 1px solid;
            }

            &:hover {
                background-color: grey;
            }
        }
    }
}
</style>
